import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=27551051&scoped=true"
import script from "./MyDocuments.vue?vue&type=script&lang=js"
export * from "./MyDocuments.vue?vue&type=script&lang=js"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=27551051&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27551051",
  null
  
)

export default component.exports